export const resumeLink =  "https://fqctzygbalkfdalqruyy.supabase.co/storage/v1/object/public/PDF/resumes/1777819177354-Pankaj_Narwade_8329965792.pdf";
export const instagramLink = "https://www.instagram.com/pankajnarwade.patil/";
export const githubLink = "https://github.com/PankajNarwade28";
export const linkedinLink =
  "https://www.linkedin.com/in/pankaj-narwade-13a053260/";
export const mailtoLink = "mailto:pankajnarwade.work@gmail.com";
export const username = "Pankaj_Narwade_28";
export const githubUsername = "PankajNarwade28";
export const leetcodelink = "https://leetcode.com/Pankaj_Narwade_28/";
export const youtubeLink =
  "https://youtube.com/@ukdvibesbypankajnarwade?si=LCubq6RFbjTGb9LB";
